import React, { useState, useEffect } from "react";
import { purchasePlanService } from "../purchasePlanService";
import { usePurchasePlanModel } from "../purchasePlanModel";
import { IPurchasePlanFields } from "../purchasePlanType";
import { momentFormat } from '@/utils/utils';
import { marginBottom } from "html2canvas/dist/types/css/property-descriptors/margin";
import useGlobalModel from "@/model/globalModel";

interface PropsType {
  printVisible: boolean;
  setPrintVisible: (visible: boolean) => void;
}

export const PurchaseTable = (props: PropsType) => {
  const { printVisible, setPrintVisible } = props;
  const { descRows, selectedRow } = usePurchasePlanModel();
  const [groupedData, setGroupedData] = useState<any>([]);
  const [formVal, setFormVal] = useState<any>({});
  useEffect(() => {
    if (printVisible) {
      purchasePlanService.one(selectedRow.planCode as string).then((res: any) => {
        let { details, ...formVal } = res.retData;
        setGroupedData(details.filter((item: any) => item.deleteFlag !== 1));
        setFormVal(formVal)
        print();
      });
    }
  }, [printVisible]);
  const { shopAndOrg: { shopCode, shopName } } = useGlobalModel()
  const print = () => {
    const el: HTMLElement | null = document.getElementById('offerPrint-container');
    const iframe: HTMLIFrameElement = document.createElement('iframe');
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow?.document;
    if (doc) {
      doc.open();
      doc.write('<link rel="stylesheet" type="text/css" href="./offerPrint.css">');
      doc.write(el?.innerHTML || '');
      doc.close();
    }

    iframe.contentWindow?.addEventListener('afterprint', () => {
      document.body.removeChild(iframe);
      setPrintVisible(false);
    });

    iframe.contentWindow?.focus();
    iframe.onload = () => {
      iframe.contentWindow?.print();
    };

    if (navigator.userAgent.indexOf("MSIE") > 0) {
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 100);
    }
  };

  return (
    <div style={{ display: 'none' }}>
      <div id="offerPrint-container" className="offerPrint-container">
        <div className="print-page">
          <div style={{ textAlign: 'center', fontSize: 16, fontFamily: "FangSong", fontWeight: 'bolder', margin: "15px 0px" }}>
            {`${shopName}作业车辆配件采购订单`}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gridRowGap: '5px', marginBottom: '2px' }}>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder' }}>{`采购方：${shopName}`}</span>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'bolder', gridColumn: '2' }}>供应商：{formVal?.supplierName}</span>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}></span>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>采购批次：{formVal?.batchCode}</span>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>联系人：{formVal?.contact}</span>
            <span style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', justifySelf: 'end' }}>日期：{formVal?.createTime == undefined ? "" : momentFormat(formVal?.createTime, "YYYY.MM.DD HH:mm")}</span>
          </div>
          <table className="mingxi" style={{ border: "1px solid black" }}>
            <thead>
              <tr style={{ lineHeight: 1.2 }}>
                {['序号', '材料编码', '产品名称', '品牌', '车型', '型号', '单位', '数量', '单价', '金额', '送货时间', '备注', '站点'].map((th, i) => (
                  <th key={i} style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal' }}>{th}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {groupedData.map((row: IPurchasePlanFields, rowIndex: number) => (
                <tr key={rowIndex} style={{ lineHeight: 1 }}>
                  <td style={{ width: 42, fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center' }}>{rowIndex + 1}</td>
                  <td style={{ width: 102, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.materialCode}</td>
                  <td style={{ width: 102, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.materialName}</td>
                  <td style={{ width: 62, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.brandCode ? row.brandName : ''}</td>
                  <td style={{ width: 112, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.model}</td>
                  <td style={{ width: 62, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.vehicleModel}</td>
                  <td style={{ width: 72, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.unitCode ? row.unitName : ''}</td>
                  <td style={{ width: 52, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.planNum}</td>
                  <td style={{ width: 52, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.price}</td>
                  <td style={{ width: 52, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.amount}</td>
                  <td style={{ width: 82, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}></td>
                  <td style={{ width: 72, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{row.note}</td>
                  <td style={{ width: 72, fontSize: 11, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{formVal.shopName}</td>
                </tr>
              ))}
              <tr style={{ lineHeight: 1 }}>
                <td colSpan={3} style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'left' }}>总计金额：</td>
                <td colSpan={6} style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}></td>
                <td style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}>{formVal.totalAmount}</td>
                <td style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}></td>
                <td style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}></td>
                <td style={{ fontSize: 12, fontFamily: "FangSong", fontWeight: 'normal', textAlign: 'center', whiteSpace: 'normal' }}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};